import { render } from "./TopBar.vue?vue&type=template&id=2bc86682&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=2bc86682&lang=css"
import "./TopBar.vue?vue&type=style&index=1&id=2bc86682&scoped=true&lang=less"
import "./TopBar.vue?vue&type=style&index=2&id=2bc86682&lang=css"

import exportComponent from "/home/runner/work/academic-pages/academic-pages/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc86682"]])

export default __exports__